﻿import { get, post, del } from '../utils'

export const getDeliveries = (
    recipient,
    limit,
    offset,
    collectionId,
    dataType,
) => {
    var query = {}
    if (recipient) query = { ...query, recipient }
    if (collectionId) query = { ...query, collectionId }
    if (dataType) query = { ...query, dataType }
    if (limit) query = { ...query, limit }
    if (offset) query = { ...query, offset }
    return get(`/delivery/deliveries`, {
        query,
    })
}

export const getDeliveryConfigs = (collectionId, dataType, limit, offset) => {
    var query = {}
    if (collectionId) query = { ...query, collectionId }
    if (dataType) query = { ...query, dataType }
    if (limit) query = { ...query, limit }
    if (offset) query = { ...query, offset }
    return get(`/delivery/configurations`, {
        query,
    })
}

export const getDeliverySpecifications = () =>
    get(`/deliveryapi/specifications`)

export const generateDelivery = (deliveryConfigurationId, createdBy) =>
    post(`/delivery/generate`, {
        body: {
            deliveryConfigurationId,
            createdBy,
        },
    })

export const createDeliveryConfig = deliveryConfig =>
    post(`/deliveryapi/configuration`, {
        body: {
            ...deliveryConfig,
        },
    })

export const deleteDeliveryConfig = id => del(`/delivery/configuration/${id}`)

export const getUniqueCollections = () =>
    get(`/delivery/deliverycollectionlist`)

export const getDeliveryActivityLog = ({ limit, offset }) => {
    return get(`/delivery/activity-log`, {
        query: {
            limit,
            ...(offset && { offset: offset * limit }),
        },
    })
}

export const getFilteredDeliveryActivityLog = ({
    limit,
    offset,
    packageId,
    recipientCode,
}) => {
    return get(`/delivery/activity-log`, {
        query: {
            packageId,
            recipientCode,
            limit,
            ...(offset && { offset: offset * limit }),
        },
    })
}

export const approveDeliveryForSC = ({ deliveryId, approvalStatus }) =>
    post(`/delivery/deliveries/approve`, {
        body: { deliveryId, approvalStatus },
    })

export const getLatestIrisDeliveryConfigurations = ({
    collectionReference,
} = {}) => {
    return get(`/deliveryapi/latestIrisDeliveryOutputConfigurations`, {
        query: {
            collectionReference,
        },
    })
}
